import styled from 'styled-components';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import colours from 'theme/atoms/colours';
import * as Cards from 'eCoach/_styles/Cards.style';
import * as Text from 'theme/components/Text.style';

export const InputGroup = styled(FormGroup)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InputTextArea = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    backgroundColor: `${colours.neutral[100]}`,
    '& fieldset': {
      border: `2px solid ${colours.neutral[200]}`,
    },
    '&.Mui-focused fieldset': {
      border: `2px solid ${colours.neutral[200]}`,
    },
  },
  '& .MuiInputBase-input': {
    color: `${colours.neutral[900]}`,
  },
});

export const ButtonsColumn = styled('div')`
  align-items: end;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Card = styled(Cards.Card)`
  gap: 20px;
  max-width: 530px;
`;

export const Label = styled(Text.P2Semibold)``;

export const PromptControls = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PromptControl = styled(Button)`
  border: 1px dashed ${colours.neutral[900]};
  border-radius: 30px;
  gap: 5px;
  justify-content: unset;
  line-height: unset;
  max-width: 500px;
  padding: 10px 20px;
  text-align: left;
  text-transform: none;
  width: fit-content;

  p {
    color: ${colours.neutral[900]};
  }

  svg {
    color: ${colours.neutral[900]};
  }

  :hover {
    background-color: ${colours.neutral[900]};

    p {
      color: ${colours.neutral[100]};
    }

    svg {
      color: white;
    }
  }
`;

export const PromptControlSelect = styled(PromptControl)`
  background-color: ${colours.neutral[100]};
  p {
    color: ${colours.neutral[900]} !important;
  }
  :hover {
    background-color: ${colours.neutral[700]};
    p {
      color: white !important;
    }
    svg {
      color: white !important;
    }
  }
`;

export const PromptControlDark = styled(PromptControl)`
  background-color: black;
  p {
    color: ${colours.neutral[100]} !important;
  }
  :hover {
    background-color: ${colours.neutral[700]};
  }
`;

export const PromptControlPrimary = styled(PromptControl)`
  background-color: ${colours.primary[500]};
  p {
    color: white !important;
  }
  :hover {
    background-color: ${colours.primary[500]};
  }
`;

export const SelectMenuContainer = styled('div')<{ open: boolean }>`
  position: absolute;
  bottom: 100%;
  right: 0;
  transform: translateY(-5px);
  width: 308px;
  max-height: 400px;
  padding: 10px;
  display: ${(props) => (props.open ? 'flex' : 'none')};
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border-radius: 20px;
  border: 0.5px solid ${colours.neutral[300]};
  background: white;
  box-shadow: 0 30px 60px -25px rgba(0, 0, 0, 0.12);
  z-index: 1300;
`;

export const SelectMenuList = styled('div')`
  width: 100%;
  max-height: 380px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
`;

export const SelectMenuItem = styled('div')<{ selected?: boolean }>`
  white-space: normal;
  word-wrap: break-word;
  border-radius: 10px;
  padding: 12px 15px;
  cursor: pointer;
  background-color: ${(props) =>
    props.selected ? colours.neutral[100] : 'transparent'};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) =>
      props.selected ? colours.neutral[100] : colours.neutral[100]};
  }
`;

export const SelectMenuItemContainer = styled('div')<{ isWrapped?: boolean }>`
  display: flex;
  align-items: ${(props) => (props.isWrapped ? 'flex-start' : 'center')};
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

export const SelectMenuItemIcon = styled('div')<{ isWrapped?: boolean }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding-top: ${(props) => (props.isWrapped ? 'calc(0.25 * 1em)' : '0')};
`;

export const SelectMenuItemText = styled(Text.P2Semibold)`
  flex: 1;
  min-width: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 1.5;
`;

export const SelectMenuItemCheck = styled('div')`
  margin-left: auto;
  flex-shrink: 0;
`;
